export default "__VITE_ASSET__ad4b09b6__"